import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table bonus report view.
 * @extends JetView
 */
export default class recordTableBonusReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Type of view
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Date', header: _('Fecha'), width: 100, sort: 'int' }, // Date column with localization
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column with localization
                { id: 'Amount', header: _('Monto'), width: 100, sort: 'int' }, // Amount column with localization
                {
                    id: 'Description',
                    header: _('Descripción'), // Description column with localization
                    width: 100,
                    sort: 'int',
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/Report/GetClientBonusReportDetail'; // API endpoint for fetching report details
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?id=' + idUser); // Load new data based on user ID
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
